import React from "react";
import PropTypes from "prop-types";

import Tooltip from "../shared/mui/Tooltip";
import AgencyAuthorization from "./Modals/AgencyAuthorization";
import ProductDetails from "./Modals/ProductDetails";
import ProviderDetails from "./Modals/ProviderDetails";
import ContractHolders from "./Modals/ContractHolders";
import Link from "../shared/Link";

/**
 * @param {FedRampProduct} fedRampProduct
 * @param {boolean} isLoggedIn
 * @param {function} setModal
 * @param {number} visibleColumn
 * @returns {Element}
 * @constructor
 */
export default function TableRow({ fedRampProduct, isLoggedIn, setModal, visibleColumn }) {
  const closeModal = () => {
    setModal(null);
  };

  function openAgencyAuthorizationModal(event) {
    setModal(<AgencyAuthorization productSeq={fedRampProduct.productSeq} productName={fedRampProduct.product}
                                  closeModal={closeModal}/>);
  }

  function openProductDetailsModal(event) {
    setModal(<ProductDetails productSeq={fedRampProduct.productSeq}
                             closeModal={closeModal} isLoggedIn={isLoggedIn}/>);
  }

  function openProviderDetailsModal(event) {
    setModal(<ProviderDetails providerSeq={fedRampProduct.providerSeq} productSeq={fedRampProduct.productSeq}
                              closeModal={closeModal}/>);
  }

  function openContractHoldersModal(event) {
    setModal(<ContractHolders productSeq={fedRampProduct.productSeq} providerSeq={fedRampProduct.providerSeq}
                              product={fedRampProduct.product} closeModal={closeModal}/>);
  }

  const tooltipTitle = <>
    For more information on this Provider or Product please use the <a className="toolTipAnchor"
                                                                       href="/sewp5public/rfitool">SEWP Market
    Research Tool</a>
  </>;

  if (visibleColumn) {
    return (<tr role="row">
      <td className="clickable blurred">
        <Link onClick={openProductDetailsModal}>{fedRampProduct.product}</Link>
      </td>
      {fedRampProduct.missingProvider ? <Tooltip
        title={tooltipTitle}>
        <td className="missingProviderTd blurred">
          {fedRampProduct.missingProvider}
        </td>
      </Tooltip> : <td className="clickable blurred">
        <Link onClick={openProviderDetailsModal}>{fedRampProduct.provider}</Link>
      </td>}
      <td className={visibleColumn === 2 ? "visible-column" : "blurred"}>{fedRampProduct.serviceModel}</td>
      <td className={visibleColumn === 3 ? "visible-column" : "blurred"}>{fedRampProduct.impactLevel}</td>
      <td className={visibleColumn === 4 ? "visible-column" : "blurred"}>{fedRampProduct.authorizationStatus}</td>
      {fedRampProduct.agencyAuthCount > 0 ? <td className="clickable blurred">
        <Link onClick={openAgencyAuthorizationModal}>Details</Link>
      </td> : <td className="blurred" title="No Agencies found to display">None</td>}
      {isLoggedIn && (fedRampProduct.contractHoldersCount > 0 ?
        <td className="clickable blurred">
          <Link onClick={openContractHoldersModal}>{fedRampProduct.contractHoldersCount}</Link>
        </td> :
        <td className="blurred" title="No Contract Holder found to display">{fedRampProduct.contractHoldersCount}</td>)}
    </tr>);
  } else {
    return (<tr role="row">
      <td className="clickable">
        <Link onClick={openProductDetailsModal}>{fedRampProduct.product}</Link>
      </td>
      {fedRampProduct.missingProvider ? <Tooltip
        title={tooltipTitle}>
        <td className="missingProviderTd">
          {fedRampProduct.missingProvider}
        </td>
      </Tooltip> : <td className="clickable">
        <Link onClick={openProviderDetailsModal}>{fedRampProduct.provider}</Link>
      </td>}
      <td>{fedRampProduct.serviceModel}</td>
      <td>{fedRampProduct.impactLevel}</td>
      <td>{fedRampProduct.authorizationStatus}</td>
      {fedRampProduct.agencyAuthCount > 0 ? <td className="clickable">
        <Link onClick={openAgencyAuthorizationModal}>Details</Link>
      </td> : <td title="No Agencies found to display">None</td>}
      {isLoggedIn && (fedRampProduct.contractHoldersCount > 0 ? <td className="clickable">
        <Link onClick={openContractHoldersModal}>{fedRampProduct.contractHoldersCount}</Link>
      </td> : <td title="No Contract Holder found to display">{fedRampProduct.contractHoldersCount}</td>)}
    </tr>);
  }

}

TableRow.propTypes = {
  fedRampProduct: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  setModal: PropTypes.func.isRequired,
  visibleColumn: PropTypes.number,
};